import {reducer} from '../helpers'

import * as lookbuilderActions from '../../actions/lookbuilder'

const initialState = {
  currentProductSlug: '',
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case lookbuilderActions.RESET_LOOKBUILDER_LOOK:
      return {currentProductSlug: ''}
    case lookbuilderActions.OPEN_LOOKBUILDER_DETAIL_VIEW:
      return {currentProductSlug: payload.productSlug}
    default:
      return null
  }
})
